export default "__VITE_ASSET__BUGXutNf__"